import React from "react"
import { useSelector } from "react-redux"
import { IDocumentAsset } from "../../../assets/state/assetsTypes"
import { getAssetById } from "../../../../shared/selectors/asset"
import { IAppState } from "../../../../app/appTypes"
import ImageZoom from "../../../../shared/components/ui/imageZoom/ImageZoom"
import LoadingSpinner from "../../../../shared/components/ui/LoadingSpinner"

interface IProps {
  assetId: string
}

const CaseImageViewer: React.FC<IProps> = (props): JSX.Element => {
  const asset = useSelector((state: IAppState) => getAssetById(state, props))
  if (!asset) return <LoadingSpinner />

  const image = asset.asset as IDocumentAsset

  return (
    <ImageZoom
      imageSrc={image.path}
    />
  )
}

export default CaseImageViewer
